<template>
  <div class="datos">
    <b-overlay variant="success" opacity="0.5" :show="Esperar">
      <b-row>
        <b-col>
          <div class="my-1 mx-0 text-center">
            <router-link to="/courier/reportes">
              <img src="/logo4.svg" />
            </router-link>
          </div>
        </b-col>
        <b-col class="pt-2 text-center" cols="8">
          <H3 class="title">Envios pendientes de entregar</H3>

          <div>Total de Envios: {{ Datos.length }}</div>
        </b-col>
      </b-row>
      <b-table-lite small v-if="Datos.length" class="tabla" bordered striped :items="Datos"></b-table-lite>
      <div v-else>
        <b-alert :show="true"> <b-icon-exclamation /> No hay informacion para mostrar!</b-alert>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  watch: {
    async Envios(v) {
      if (v.length) {
        let clientes = [];

        let clientesID = v.map((item) => item.Recibe);

        do {
          let IDs = clientesID.slice(0, 10);
          clientesID.splice(0, 10);

          await db
            .collection("Cliente")
            .where(firebase.firestore.FieldPath.documentId(), "in", IDs)
            .get()
            .then((tmp) => {
              let datos = tmp.docs.map((c) => {
                let da = c.data();
                return {
                  id: c.id,
                  Nombre: da.Nombre,
                  Region: da.Region,
                  Deuda: da.Deuda,
                  Celular: da.Celular,
                };
              });

              clientes = clientes.concat(datos);
            });
        } while (clientesID.length > 0);

        let envs = v.map((item) => {
          let cliente = clientes.filter((cli) => cli.id == item.Recibe)[0];

          let rs = {
            Guia: item.NoGuia,
            Recibe: cliente,
            PAQ: item.Contenido.filter((p) => {
              return p.Tipo == "Paquete";
            }).length,
            Entrega: item.Entrega,
          };

          rs.Recibe = cliente.Nombre;
          rs.Deuda = cliente.Deuda || 0;
          rs.RGN = cliente.Region;
          rs.Deuda = rs.Deuda > 0 ? "PENDIENTE" : "Cancelado";
          rs.Celular = cliente.Celular;

          return rs;
        });

        this.Esperar=false;
        this.Datos=envs;
      }
    },
    EnviosDB() {
      this.Envios = this.EnviosDB.filter((env) => env.Entregado !== true);
    },
  },

  firestore: {
    EnviosDB: db.collection("Envios"),
  },

  data() {
    return {
      Esperar: true,
      EnviosDB: [],
      Envios: [],
      Datos: [],
    };
  },
  props: ["viaje"],
  beforeCreate() {
    this.$root.$emit("Imprimir", { ok: true });
  },
};
</script>

<style scoped>
.datos {
  width: 19.5cm;
  border: 1p solid black;
}
.tabla {
  font-size: 14px;
  margin-top: 20px;
}
</style>
